module.exports = __webpack_public_path__ + "static/media/confirm.c9325be4.svg";